import { useTranslation } from "react-i18next";
import styles from "./HomeCard.module.scss";
import Button from "../button/Button";
import Modal from "../modal/modal";
import { useState } from "react";
import GetPremiumModal from "../modals/GetPremiumModal/GetPremiumModal";
import OrderSummaryModal from "../modals/OrderSummaryModal/OrderSummaryModal";

interface HomeCardProps {
  title: string;
  subtitle: string;
  icon: string;
  onClick?: () => void;
  trial?: boolean;
  hover?: boolean;
}

const HomeCard: React.FC<HomeCardProps> = ({
  title,
  subtitle,
  icon,
  onClick,
  trial,
  hover,
}) => {
  const [isModalUpdateVisible, setIsModalUpdateVisible] = useState(false);
  const [isModalOrderVisible, setIsModalOrderVisible] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Modal
        isOpen={isModalUpdateVisible}
        setIsVisible={() => setIsModalUpdateVisible(false)}
      >
        <GetPremiumModal
          setIsModalUpdateVisible={setIsModalUpdateVisible}
          setIsModalOrderVisible={setIsModalOrderVisible}
        />
      </Modal>

      <Modal
        isOpen={isModalOrderVisible}
        setIsVisible={() => setIsModalOrderVisible(false)}
      >
        <OrderSummaryModal />
      </Modal>
      {trial ? (
        <div className={styles.trial}>
          <div className={styles.trial_info}>
            <p className={styles.trial_info_offer}>Exclusive Offer:</p>
            <p className={styles.trial_info_title}>{title}</p>
            <p className={styles.trial_info_subtitle}>{subtitle}</p>
            <p className={styles.trial_info_text}>
              Boost performance, security, and more with Fortect Premium.
            </p>
            <Button
              onClick={() => setIsModalUpdateVisible(true)}
              text={"Upgrade Now"}
              type="expired"
              classNames={styles.trial_info_button}
            />
          </div>
          <img src={icon} alt="trial" className={styles.trial_img} />
        </div>
      ) : (
        !hover && (
          <div onClick={onClick} className={styles.root}>
            <img src={icon} alt="icon" className={styles.root_icon} />
            <div>
              <h3 className={styles.root_title}>{t(title)}</h3>
              <h4 className={styles.root_subtitle}>{t(subtitle)}</h4>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default HomeCard;
